/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Member not found" |
*
* @param {User_Detail_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_not_found = /** @type {((inputs?: User_Detail_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membre introuvable")
	if (locale === "es") return /** @type {LocalizedString} */ ("Miembro no encontrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Membro não encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Membro non trovato")
	return /** @type {LocalizedString} */ ("Member not found")
});